import './Drawer.scss';

import cn from 'classnames';
import React from 'react';
import { Drawer as RsuiteDrawer } from 'rsuite';

import DrawerDialogContainer from '@/ebat/components/blocks/Header/MenuComponents/Drawer/DrawerDialogContainer/DrawerDialogContainer';
import {
  MENU_TYPE_DRAWER,
  useHeaderMenuContext,
} from '@/ebat/contexts/Header/HeaderMenuContext/HeaderMenuContext';

import { DrawerDefaultProps, DrawerPropTypes } from './Drawer.proptypes';
import DrawerContainer from './DrawerContainer/DrawerContainer';

const Drawer = () => {
  const {
    isOpen,
    handleClose,
    getPlacement,
    content,
    name,
  } = useHeaderMenuContext();

  return (
    <RsuiteDrawer
      as={DrawerContainer}
      dialogAs={DrawerDialogContainer}
      className={cn('header-drawer-dialog', `header-drawer-dialog-${name}`)}
      placement={getPlacement(MENU_TYPE_DRAWER)}
      open={isOpen({ type: MENU_TYPE_DRAWER })}
      onClose={handleClose}
      enforceFocus={false}
      autoFocus={false}
    >
      <RsuiteDrawer.Body>{content}</RsuiteDrawer.Body>
    </RsuiteDrawer>
  );
};
//HeaderDrawer

Drawer.defaultProps = {
  ...DrawerDefaultProps,
};

Drawer.propTypes = {
  ...DrawerPropTypes,
};

export default Drawer;
